var chunkToChildrenMap = {
	"2742": [
		7960,
		45262,
		85200,
		5444
	],
	"32212": [
		7960,
		45262,
		85200,
		5444
	],
	"76409": [
		93741,
		96242,
		6602
	],
	"77195": [
		5444
	],
	"79696": [
		7960,
		45262,
		85200,
		5444
	],
	"95438": [
		21689,
		18645,
		10697,
		27535,
		37371,
		78195,
		98375,
		76409,
		49799
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));